export const REACT_QUERY_CACHE_KEYS = {
  GET_COMMENT_TEMPLATES: 'get-comment-templates',
  GET_EMAIL_NOTIFICATIONS: 'get-email-notifications',
  GET_FREEE_CONNECTED: 'get-freee-connected',
  GET_FREEE_SYNC_STATUS: 'get-freee-sync-status',
  GET_FREEE_CONNECTED_USER: 'get-freee-connected-user',
  GET_IDENTITY_VERIFICATIONS: 'get-identity-verifications',
  GET_IDENTITY_VERIFICATIONS_LATEST: 'get-identity-verifications-latest',
  GET_MONTHLY_USER_CARD_SUMMARIES: 'get-monthly-user-card-summaries',
  GET_PURCHASE_APPLICATIONS_REQUESTED_COUNT:
    'get-purchase-applications-requested-count',
  GET_PURCHASE_APPLICATION_TEMPLATES: 'get-purchase-application-templates',
  GET_USER_ACCOUNTS_WITH_DEFAULT_COMMENT_TEMPLATE:
    'get-user-accounts-with-default-comment-template',
  GET_USER_ACCOUNT_GROUPS: 'get-user-account-groups',
  GET_USER_ACCOUNT_YEAR_MONTH_SUMMARY: 'get-user-account-year-month-summary',
  GET_CURRENT_CARD_ASSOCIATED_WITH_THE_USER_ACCOUNT:
    'get-current-card-associated-with-the-user-account',
  GET_USER_BY_ID: 'get-user-by-id',
  GET_USER_ME: 'get-user-me',
  GET_USERS: 'get-users',
  GET_CATEGORIES_OF_PURCHASE_APPLICATION_TEMPLATE:
    'get-categories-of-purchase-application-template',
  GET_ADMINS: 'get-admins',
  GET_BOOKKEEPERS: 'get-bookkeepers',
  GET_CARDS: 'get-cards',
  GET_CARD_TRANSACTIONS: 'get-card-transactions',
  GET_CARD_MONTHLY_TRANSACTIONS: 'get-card-monthly-transactions',
  GET_CARD_MONTHLY_TRANSACTIONS_COUNT: 'get-card-monthly-transactions-count',
  GET_FRAUD_LOCKED_CARD_TRANSACTION: 'get-fraud-locked-card-transaction',
  GET_SUSPICIOUS_TRANSACTIONS: 'get-suspicious-transactions',
  GET_APPROVERS: 'get-approvers',
  GET_CAN_ACTIVATE_CARD: 'get-can-activate-card',
  GET_TFA_APP_QR_CODE: 'get-tfa-app-qr-code',
  GET_TFA_APP_RECOVERY_CODE: 'get-tfa-app-recovery-code',
  GET_TFA_SMS_RECOVERY_CODE: 'get-tfa-sms-recovery-code',
  GET_BANK_ACCOUNT_CONFIRMED_ACTIVITIES:
    'get-bank-account-confirmed-activities',
  GET_GUARANTEE_MONEY_BALANCE_HISTORY: 'get-guarantee-money-balance-history',
  GET_ORGANIZATION_ME: 'get-organization-me',
  GET_MONEYTREE_STATUS: 'get-moneytree-status',
  GET_MONEYTREE_OAUTH_URL: 'get-moneytree-oauth-url',
  VERIFY_MONEYTREE_CONNECTIONS: 'verify-moneytree-connections',
  GET_ADDRESS: 'get-address',
  GET_ANNUAL_FEES_ELIGIBILITY: 'get-annual-fees-eligibility',
  GET_AVAILABLE_FEATURES: 'get-available-features',
  GET_SEARCH_PAYMENT_REQUESTS: 'get-search-payment-requests',
  GET_SEARCH_BANK_TRANSFERS: 'get-search-bank-transfers',
  DOWNLOAD_PAYMENT_REQUESTS_CSV: 'download-payment-requests-csv',
  GET_FREEE_ACCOUNT_ITEMS: 'get-freee-account-items',
  GET_FREEE_TAXES: 'get-freee-taxes',
  GET_FREEE_ITEMS: 'get-freee-items',
  GET_FREEE_SECTIONS: 'get-freee-sections',
  GET_FREEE_MEMO_TAGS: 'get-freee-memo-tags',
  GET_FREEE_SEGMENT_TAGS: 'get-freee-segment-tags',
  GET_FREEE_PARTNERS: 'get-freee-partners',
  GET_DOWNLOAD_BANK_TRANSFER_FILE: 'get-download-bank-transfer-file',
  GET_MERCHANT_ORGANIZATION_USER_ACCOUNT_YEAR_MONTH_SUMMARY:
    'get-merchant-organization-user-account-year-month-summary',
  GET_PURCHASE_APPLICATION_TEMPLATES_DETAIL:
    'get-purchase-application-templates-detail',
  GET_ORGANIZATION_CHART_ROLES: 'get-organization-chart-roles',
  GET_ORGANIZATION_CHART_DEPARTMENTS: 'get-organization-chart-departments',
  GET_ORGANIZATION_CHART_EMPLOYEES: 'get-organization-chart-employees',
  GET_PAYMENT_REQUEST_EVIDENCE_FILE: 'get-payment-request-evidence-file',
  GET_PAYMENT_REQUEST_DRAFT_EVIDENCE_FILE:
    'get-payment-request-draft-evidence-file',
  GET_PAYMENT_REQUEST_DETAIL: 'get-payment-request-detail',
  GET_CAN_DEACTIVATE: 'get-can-deactivate',
  GET_ANALYSIS_INVOICE_OF_PAYMENT_REQUEST:
    'get-analysis-invoice-of-payment-request',
  GET_AGREEMENT_REQUESTS: 'get-agreement-requests',
  GET_EVIDENCE_FILE: 'get-evidence-file',
  GET_EVIDENCE_FILES: 'get-evidence-files',
  GET_SLACK_CARD_NOTIFICATION_SETTINGS: 'get-slack-card-notification-settings',
  GET_SLACK_TEAM: 'get-slack-team',
  GET_SLACK_CHANNELS: 'get-slack-channels',
  GET_SLACK_CHANNEL: 'get-slack-channel',
  GET_SLACK_NOTIFICATION_SETTINGS_FOR_PURCHASE_APPLICATION:
    'get-slack-notification-settings-for-purchase-application',
  GET_DRAFT_PAYMENT_REQUESTS_ONLY_CREATED_OWN:
    'get-draft-payment-requests-only-created-own',
  GET_PAYMENT_REQUESTS_BANK_ACCOUNTS_LIST:
    'get-payment-requests-bank-accounts-list',
  GET_DRAFT_PAYMENT_REQUEST: 'get-draft-payment-request',
  GET_FREEE_COMPANIES: 'get-freee-companies',
  GET_FREEE_REDIRECT_URL: 'get-freee-redirect-url',
  GET_DRAFT_PAYMENT_REQUEST_EVIDENCE_FILE:
    'get-draft-payment-request-evidence-file',
  QUERY_BY_IDS_PAYMENT_REQUESTS: 'query-by-ids-payment-requests',
  GET_BANK_BY_NAME: 'get-bank-by-name',
  GET_BRANCH: 'get-branch',
  DOWNLOAD_PAYMENT_REQUESTS_CSV_FOR_PAYMENT_REQUEST_IDS_SPECIFICATION:
    'download-payment-requests-csv-for-payment-request-ids-specification',
  GET_BANK_TRANSFER: 'get-bank-transfer',
  DOWNLOAD_BANK_TRANSFERS_CSV: 'download-bank-transfers-csv',
  SEARCH_MY_PAYMENT_REQUESTS: 'search-my-payment-requests',
  GET_EVIDENCES: 'get-evidences',
  SEARCH_EVIDENCES: 'search-evidences',
  GET_EVIDENCES_COUNT: 'get-evidences-count',
  GET_CARD_TRANSACTION_EVIDENCE_RECORDS:
    'get-card-transaction-evidence-records',
  GET_PAYMENT_REQUEST_EVIDENCE_RECORDS: 'get-payment-request-evidence-records',
  GET_PAYMENT_REQUEST_EVIDENCE_RECORD_FILE:
    'get-payment-request-evidence-record-file',
  GET_CARD_TRANSACTION_EVIDENCE_RECORD_IMAGE:
    'get-card-transaction-evidence-record-image',
  GET_GUARANTEE_MONEY_DEPOSITS_FOR_ORGANIZATION:
    'get-guarantee-money-deposits-for-organization',
  GET_EARLIEST_EXPIRING_GUARANTEE_MONEY_FOR_ORGANIZATION:
    'get-earliest-expiring-guarantee-money-for-organization',
  COMPLETE_REDIRECT_FROM_SLACK: 'complete-redirect-from-slack',
  GET_SLACK_EVIDENCE_REMINDER: 'get-slack-evidence-reminder',
  GET_SLACK_EVIDENCE_REMINDER_PER_CHANNEL:
    'get-slack-evidence-reminder-per-channel',
  GET_SSO_JWT: 'get-sso-jwt',
  GET_SAML_CONFIGURATION: 'get-saml-configuration',
  GET_SAML_METADATA: 'get-saml-metadata',
  GET_LOGIN_OPTIONS: 'get-login-options',
  GET_SLACK_VERSION: 'get-slack-version',
  GET_CARD_TRANSACTION_DETAILS: 'get-card-transaction-details',
  GET_MONTHLY_CARD_BILL: 'get-monthly-card-bill',
  USERS_PASSWORD_RESET_CHECK_GET: 'users-password-reset-check-get',
  GET_SLACK_CHANNELS_WITH_CURSOR: 'get-slack-channels-with-cursor',
  GET_COMMENT: 'get-comment',
  GET_DEFAULT_COMMENT_TEMPLATE: 'get-default-comment-template',
  GET_EVIDENCE_INFORMATION_FOR_CARD_TRANSACTIONS:
    'get_evidence_information_for_card_transactions',
  GET_EVIDENCE_IMAGE: 'get-evidence-image',
  GET_TRANSACTION_EVIDENCE_EMAIL_ADDRESS:
    'get-transaction-evidence-email-address',
  GET_TRANSACTION_EVIDENCE_EMAILS: 'get-transaction-evidence-emails',
  GET_TRANSACTION_EVIDENCE_EMAIL_FILE: 'get-transaction-evidence-email-file',
  GET_BALANCE_STATE: 'get-balance-state',
  GET_GUARANTEE_MONEY_BALANCE_INFORMATION_FOR_ORGANIZATION:
    'get-guarantee-money-balance-information-for-organization',
  GET_DEPOSIT_BANK_ACCOUNT: 'get-deposit-bank-account',
  GET_DEPOSIT_RESTRICTIONS: 'getDepositRestrictions',
  GET_LOCK_STATUS_OF_EVIDENCES: 'get-lock-status-of-evidences',
  GET_CARD_DETAIL: 'get-card-detail',
  GET_PURCHASE_APPLICATIONS: 'get-purchase-applications',
  GET_CAN_REQUEST_SENDING_CARD: 'get-can-request-sending-card',
  GET_ORG_ACCOUNT_STATE: 'get-org-account-state',
  GET_ROLES_WITH_TOP_RELATED_RESOURCES: 'get-roles-with-top-related-resources',
  GET_AVAILABLE_MERCHANT_CATEGORY_OPTIONS:
    'get-available-merchant-category-options',
  GET_AVAILABLE_CURRENCY_OPTIONS: 'get-available-currency-options',
  GET_ORGANIZATION_CARDS_LIGHT: 'get-organization-cards-light',
  GET_ORGANIZATION_CARDS_EXTENDED: 'get-organization-cards-extended',
  GET_SCIM_CONFIGURATION: 'get-scim-configuration',
  GET_SCIM_ACCESS_TOKEN: 'get-scim-access-token',
  GET_MERCHANT_ORG_BLOCK: 'get-merchant_org_block',
  GET_ORGANIZATION: 'get-organization',
  GET_MERCHANT_ORG_BLOCK_LIST: 'get-merchant-org-block-list',
  GET_MERCHANT_GENERAL_BLOCK_LIST: 'get-merchant-general-block-list',
  GET_MERCHANT_GENERAL_BLOCK_DETAIL: 'get-merchant-general-block-detail',
  GET_MESSAGES: 'get-messages',
  GET_MESSAGE_DETAIL: 'get-message-detail',
  GET_UNREAD_MESSAGES_COUNT: 'get-unread-messages-count',
  GET_SUBMITTED_TRUSTDOCK_DATA: 'get-submitted-trustdock-data',
  GET_TRUSTDOCK_VERIFICATIONS: 'get-trustdock-verifications',
  GET_VENTURE_CAPITALS: 'get-venture-capitals',
  SEARCH_CORPORATIONS_IN_NATIONAL_TAX_AGENCY:
    'search-corporations-in-national-tax-agency',
  GET_BUSINESS_DESCRIPTIONS: 'get-business-descriptions',
  GET_TEAMS_TEAM: 'get-teams-team',
  GET_TEAMS_CHANNELS_WITH_CURSOR: 'get-teams-channels-with-cursor',
  GET_TEAMS_CHANNEL: 'get-teams-channel',
  GET_TEAMS_CARD_NOTIFICATION_SETTINGS: 'get-teams-card-notification-settings',
  GET_TRUSTDOCK_SUBMIT_IDENTIFICATION_DOCUMENT_PUBLISH_URL:
    'get-trustdock-submit-identification-document-publish-url',
  GET_TRUSTDOCK_IDENTITY_VERIFICATIONS: 'get-trustdock-identity-verifications',
  GET_ORGANIZATION_PAYMENTS: 'get-organization-payments',
  GET_ORGANIZATIONS_BILLS: 'get-organizations-bills',
  GET_REWARDS: 'get-rewards',
  GET_INVOICE_LIST: 'get-invoice-list',
  GET_CARD_BILL: 'get-card-bill',
  ERROR_BILLS: 'error-bills',
  USAGE_FEES: 'usage-fees',
  SEARCH_ORGANIZATIONS: 'search-organizations',
  GET_ZEUS_ORGANIZATIONS: 'get-zeus-organizations',
  GET_ZEUS_ORGANIZATION_CREATE_REQUESTS:
    'get-zeus-organization-create-requests',
  GET_ZEUS_ONBOARDING_REQUESTS: 'get-zeus-onboarding-requests',
  GET_ZEUS_ONBOARDING_REQUEST_BY_ID: 'get-zeus-onboarding-request-by-id',
  CHECK_DUPLICATE_EMAIL_ADDRESSES: 'check-duplicate-email-addresses',
  GET_ISSUABLE_STATUS: 'get-issuable-status',
  VERIFY_PC_JWT_SSO: 'verify-pc-jwt-sso',
  GET_REWARD_POINT_TRANSACTIONS: 'get-reward-point-transactions',
  GET_REWARD_POINT_BALANCE: 'get-reward-point-balance',
  GET_ONBOARDING_REQUEST_PERSONAL_INFO: 'get-onboarding-request-personal-info',
  GET_KYC_READER_USERS: 'get-kyc-reader-users',
  HYDRA_ADMIN_LOGIN_REQUEST: 'hydra-admin-login-request',
  HYDRA_ADMIN_CONSENT_REQUEST: 'hydra-admin-consent-request',
  ZEUS_ORGANIZATION_IDENTITY_VERIFICATIONS_FOR_PRESIDENT:
    'zeus-organization-identity-verifications-for-president',
  GET_MONTHLY_CARD_TRANSACTIONS_FOR_THE_ORGANIZATION:
    'get-monthly-card-transactions-for-the-organization',
  GET_MONTHLY_CARD_TRANSACTIONS_FOR_THE_USER:
    'get-monthly-card-transactions-for-the-user',
  GET_FREEE_CONNECTION_LINKED_ACCOUNT_FOR_ACCOUNTING:
    'get-freee-connection-linked-account-for-accounting',
  GET_FREEE_CONNECTION_SETTINGS_FOR_ACCOUNTING:
    'get-freee-connection-settings-for-accounting',
  GET_FREEE_COMPANIES_FOR_ACCOUNTING: 'get-freee-companies-for-accounting',
  GET_USER_CARDS_LIGHT_FOR_ROLE_RESOURCES:
    'get-user-cards-light-for-role-resources',
  GET_CREDIT_JOB_STATUS: 'get-credit-job-status',
  GET_CREDIT_ACCOUNT_CONNECTION_STATUS: 'get-credit-account-connection-status',
  GET_CURRENT_ETC_CARD: 'get-current-etc-card',
  GET_ETC_CARD_DETAIL: 'get-etc-card-detail',
  GET_ETC_CARD_TRANSACTIONS: 'get-etc-card-transactions',
  GET_ETC_CARDS: 'get-etc-cards',
  GET_ETC_ACCOUNT: 'get-etc-account',
  GET_ETC_AMOUNTS: 'get-etc-amounts',
  GET_CANARY_ROUTING_STATUS: 'get-canary-routing-status',
  GET_MONTHLY_SERVICE_CHARGES: 'get-monthly-service-charges',
  DOWNLOAD_ETC_ACCOUNTING_CSV: 'download-etc-accounting-csv',
  GET_OL_INFO_SHARING_CONSENT: 'get-ol-info-sharing-consent',
  // Do Not Remove this line ===@import cache key ===
} as const
